/*
 * @Author: zxf
 * @Date: 2021-10-15 13:37:24
 * @Description: file content
 * @FilePath: \neolix-map-sdk\src\snap\SnapBase.js
 */
import Singleton from '../clazz/Singleton';
import {Utils} from "../utils.js";
import {SceneRegister} from "../register/SceneRegister.js";
import {GemmetryAlgorithm} from "../algorithm/geometry.js";
import { Tiles } from './../utils/Tiles.js';
import { RenderController } from "../render/RenderController.js";
export class Snap extends Singleton{
	// 初始化
	constructor(options) {
		super(options);
		this.viewer = options.viewer;
		this.scene = options.viewer.scene;
		this.renderer = options.viewer.renderer;
		this.domElement = this.renderer.domElement;
		this.sceneRegister = SceneRegister.getInstance();
		this.gemmetryAlgorithm = GemmetryAlgorithm.getInstance();
		this.rendererController = RenderController.getInstance();
		this.tiles = Tiles.getInstance();
    }

	snap(point, options = {}) {
		const tile = this.tiles.getTileByPoint(point);
		const threshold = 5;
		var bounds = turf.polygon([[
			[point.x - threshold, point.y - threshold],
			[point.x - threshold, point.y + threshold],
			[point.x + threshold, point.y + threshold],
			[point.x + threshold, point.y - threshold],
			[point.x - threshold, point.y - threshold]
		]]);
		let scenes = this.sceneRegister.scenes;
		let tempScenes = this.sceneRegister.tempScenes;
		let camera = this.scene.getActiveCamera();
		let interactables = [];
		for (let sceneKey in scenes) {
			if(!~['feedback','temporaryFeedback','staticFeedback','track','drivingGeofence','qualityPoint'].indexOf(sceneKey)&& scenes[sceneKey].visible && !scenes[sceneKey].renderType &&!scenes[sceneKey].isHelper) {
				const tileData = scenes[sceneKey].tiles[`${tile.x}_${tile.y}`];
				if(!tileData) {
					continue
				}
				for(let i = 0; i < tileData.children.length; i++) {
					const node = tileData.children[i];
					if (node.visible && !node.isScene && node.prop) {
						let geometry = node.prop.geo;
						if(geometry) {
							let obj = {};
							obj.geo = Utils.worldVectorToScreenVector(geometry, this.domElement, camera);
							obj.object = node.prop;
							obj.object.node = options.node ? node : undefined;
							interactables.push(obj);
						}
					}
				}
			} else if (sceneKey == 'temporaryFeedback') {
				for(let key in tempScenes) {
					if(tempScenes[key].visible) {
						for(let i = 0; i <tempScenes[key].children.length; i++) {
							const node =tempScenes[key].children[i];
							if (node.visible && !node.isScene && node.prop) {
								let geometry = node.prop.geo;
								if(geometry) {
									let obj = {};
									obj.geo = Utils.worldVectorToScreenVector(geometry, this.domElement, camera);
	
									obj.object = node.prop;
									interactables.push(obj);
								}
							}
						}
					}
				}

			}else if(sceneKey==='drivingGeofence'&& scenes[sceneKey].visible) {
				for(let i = 0; i < scenes[sceneKey].children.length; i++) {
					const node = scenes[sceneKey].children[i];
					if (node.visible && !node.isScene && node.prop) {
						let geometry = node.prop.geo;
						if(geometry) {
							let obj = {};
							obj.geo = Utils.worldVectorToScreenVector(geometry, this.domElement, camera);

							obj.object = node.prop;
							interactables.push(obj);
						}
					}
				}
			}
		}

		let features = [];
		for(let i = 0;i< interactables.length;i++) {
			let ele = interactables[i];
			if(!turf.booleanDisjoint(ele.geo, bounds)) {
				const id = ele.object;
				const featureFilter = features.filter(item => item.id == id);
				if(featureFilter.length == 0) {
					features.push(ele.object);
				}
			}
		}
		return features;
	}

	snapFeature(type) {
		
	}

	snapFeatureVectors(mouse, geometry) {
		const threshold = 5;
		let bounds = turf.polygon([[
			[mouse.x - threshold, mouse.y - threshold],
			[mouse.x - threshold, mouse.y + threshold],
			[mouse.x + threshold, mouse.y + threshold],
			[mouse.x + threshold, mouse.y - threshold],
			[mouse.x - threshold, mouse.y - threshold]
		]]);
		let camera = this.scene.getActiveCamera();
		for(let i = 0;i < geometry.length;i++) {
			let vector = Utils.worldVectorToScreenVector({
				coordinates: [geometry[i].x, geometry[i].y, geometry[i].z],
				type: 'Point'
			}, this.domElement, camera);
			if(!turf.booleanDisjoint(vector, bounds)) {
				return {
					point: geometry[i],
					index: i
				}
			}
		}
		return null;
	}

	snapFeatureLine(mouse, geometry) {
		const threshold = 3;
		let bounds = turf.polygon([[
			[mouse.x - threshold, mouse.y - threshold],
			[mouse.x - threshold, mouse.y + threshold],
			[mouse.x + threshold, mouse.y + threshold],
			[mouse.x + threshold, mouse.y - threshold],
			[mouse.x - threshold, mouse.y - threshold]
		]]);
		let camera = this.scene.getActiveCamera();
		for(let i = 0; i < geometry.length - 1; i++) {
			let line = Utils.worldVectorToScreenVector({
				coordinates: [[geometry[i].x, geometry[i].y, geometry[i].z], [geometry[i + 1].x, geometry[i + 1].y, geometry[i + 1].z]],
				type: 'LineString'
			}, this.domElement, camera);
			if(!turf.booleanDisjoint(line, bounds)) {
				return {
					index: i,
					nextIndex: i + 1
				}
			}
		}
		return null;
	}

	snapPointCloud(mouse, camera, viewer, pointclouds, params = {}) {
		return Utils.getMousePointCloudIntersection(
			mouse, camera, viewer, pointclouds, params);
	}

	snapGeometry(mouse, geometry) {
		const threshold = 3;
		let bounds = turf.polygon([[
			[mouse.x - threshold, mouse.y - threshold],
			[mouse.x - threshold, mouse.y + threshold],
			[mouse.x + threshold, mouse.y + threshold],
			[mouse.x + threshold, mouse.y - threshold],
			[mouse.x - threshold, mouse.y - threshold]
		]]);
		let mousePoint = turf.point([mouse.x, mouse.y]);
		let camera = this.scene.getActiveCamera();
		for(let i = 0; i < geometry.length - 1; i++) {
			let line = Utils.worldVectorToScreenVector({
				coordinates: [[geometry[i].x, geometry[i].y, geometry[i].z], [geometry[i+1].x, geometry[i+1].y, geometry[i+1].z]],
				type: 'LineString'
			}, this.domElement, camera);
			if(!turf.booleanDisjoint(line, bounds)) {
				let snapped = turf.nearestPointOnLine(line, mousePoint, {units: 'miles'});
				const lineGeo = line.geometry.coordinates;
				const pointGeo = snapped.geometry.coordinates;
				let precent = (pointGeo[0] - lineGeo[0][0]) / (lineGeo[1][0] - lineGeo[0][0]);
			}
		}
	}

	snapByRect(points, featureType) {
		const tiles = this.tiles.getTilesByRect(points);
		const bounds = turf.polygon([points])
		const scenes = this.sceneRegister.scenes;
		const camera = this.scene.getActiveCamera();
		let interactables = [];
		for (let sceneKey in scenes) {
			if((!featureType || featureType.find(type => type === sceneKey))
				&& !/feedback|temporaryFeedback|staticFeedback|track|qualityPoint/.test(sceneKey)
				&& scenes[sceneKey].visible
        && !scenes[sceneKey].isHelper
				&& !scenes[sceneKey].renderType
			) {
				for(let tile of tiles) {
					let tileData = scenes[sceneKey].tiles[`${tile.x}_${tile.y}`] ;
					if(this.rendererController.featureConfig[sceneKey]&&this.rendererController.featureConfig[sceneKey].server) {
						tileData=scenes[sceneKey]
					}
					if(!tileData) {
						continue;
					}
					for(let i = 0; i < tileData.children.length; i++) {
						const node = tileData.children[i];
						if (node.visible && !node.isScene && node.prop) {
							let geometry = node.prop.geo;
							if(geometry) {
								let obj = {};
								obj.geo = Utils.worldVectorToScreenVector(geometry, this.domElement, camera);
								obj.object = node.prop;
								interactables.push(obj);
							}
						}
					}
				}
			}
		}

		let features = [];
		for(let i = 0;i< interactables.length;i++) {
			let ele = interactables[i];
			if(!turf.booleanDisjoint(ele.geo, bounds)) {
				const { id } = ele.object;
				const featureFilter = features.filter(item => item.id == id);
				if(featureFilter.length == 0) {
					features.push(ele.object);
				}
			}
		}
		return features;
	}
}
